import { render, staticRenderFns } from "./WalletButton.vue?vue&type=template&id=3a791742&scoped=true"
import script from "./WalletButton.vue?vue&type=script&lang=js"
export * from "./WalletButton.vue?vue&type=script&lang=js"
import style0 from "./WalletButton.vue?vue&type=style&index=0&id=3a791742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a791742",
  null
  
)

export default component.exports